import { TABLE_VIEW_SHARED_TYPES } from 'src/constants/tableView';

// eslint-disable-next-line import/prefer-default-export
export function getExistingShareType(user, visibleToRoles) {
  const hasRoles = Array.isArray(visibleToRoles) && visibleToRoles.length > 0;
  let editedShareType = null;

  if (hasRoles) {
    editedShareType = TABLE_VIEW_SHARED_TYPES.ROLE_SPECIFIC;
  } else if (user === null) {
    editedShareType = TABLE_VIEW_SHARED_TYPES.GLOBAL;
  } else {
    editedShareType = TABLE_VIEW_SHARED_TYPES.PRIVATE;
  }
  return editedShareType;
}
